








import { Component, Vue, Prop } from 'vue-property-decorator';

// 2020/10/23現在、内容はTopContentListと全く同じ

@Component
export default class Parts extends Vue {
  @Prop({ type: Array, required: true })
  public list!: string[];
}
